import React, { useContext, useState } from 'react';
import { TextField, Tabs, Tab } from '@mui/material';
import {
  handleChangeFormatoCustom,
  handleFormatoChange,
  updateNameCustom,
} from '../../helpers/Admin/cardContentArteFinal';
import UpdateIcon from '@mui/icons-material/Update';
import FooterCard from './FooterCard';
import DropdownOption from '../common/SelectOption';
import { ShoppingCartContext } from '../../context/ShoppingCartContext';
import { ArteFinalContext_v2 } from '../../context/ArteFinalContext_v2';
import SelectMaterial from './SelectMaterial';
import GridOnIcon from '@mui/icons-material/GridOn';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const MAX_LENGTH = 30;

const ContentArteNotDescargable = ({ arteFinal }) => {
  const [activeTab, setActiveTab] = useState(0);
  const shouldTruncate = arteFinal.nameArteFinal.length > MAX_LENGTH;
  const displayText = shouldTruncate
    ? `${arteFinal.nameArteFinal.substring(0, MAX_LENGTH)}...`
    : arteFinal.nameArteFinal;

  const { shoppingCart_v2, setShoppingCart_v2 } = useContext(ShoppingCartContext);
  const { formatSelected, setFormatSelected, setFormatProviderSelected } = useContext(ArteFinalContext_v2);

  return (
    <div className="content-arte-not-descargable">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.2rem',
            alignItems: 'center',
          }}
        >
          {shouldTruncate ? (
            <p style={{ fontWeight: 'bold', margin: '0', cursor: 'default' }}>{displayText.toUpperCase()}</p>
          ) : (
            <p style={{ fontWeight: 'bold', margin: '0' }}>{arteFinal.nameArteFinal.toUpperCase()}</p>
          )}
          {/* <span style={{ fontStyle: 'italic', margin: '0' }}>{arteFinal.codeArteFinal}</span> */}
        </div>

        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          variant="fullWidth"
          sx={{
            minHeight: 28,
            borderBottom: '1px solid #e0e0e0',
            '& .MuiTab-root': {
              minHeight: 28,
              fontSize: '0.7rem',
              padding: '2px 8px',
              textTransform: 'none',
            },
            '& .MuiTabs-indicator': { height: 2 }, // ← sin backgroundColor, usa el default

            '& .MuiTabs-indicator': {
              height: 2,
              backgroundColor: '#c2322b',
            },
            '& .MuiTab-root.Mui-selected': {
              color: '#c2322b',
            },
          }}
        >
          <Tab label="Formato" icon={<GridOnIcon sx={{ fontSize: 14 }} />} iconPosition="start" />
          <Tab label="Descripción" icon={<FormatListBulletedIcon sx={{ fontSize: 14 }} />} iconPosition="start" />
        </Tabs>
        {activeTab === 0 && (
          <>
            <DropdownOption
              isInformational={arteFinal.isInformational}
              options={arteFinal.formatos.map((formato) => ({
                value: formato.formatoId,
                formatName: formato.formatoName,
                formatoPrice: formato.formatoPrice,
                formatoCode: formato.formatoCode,
                formatoMaterial: formato.formatoMaterial,
                formatoCustom: formato.formatoCustom,
                arteFinal: arteFinal._id,
              }))}
              id={`select-formatos-arte-final-${arteFinal._id}`}
              onChange={(value) =>
                handleFormatoChange({
                  setFormatSelected,
                  setFormatProviderSelected,
                  arteFinal,
                  event: value,
                })
              }
            />

            {arteFinal.formatos.find((formato) => formato?.formatoId === formatSelected?.formatoId)?.formatoId ===
              formatSelected?.formatoId &&
              formatSelected?.formatoCustom && (
                <div className="w-100 d-flex fd-c gap-1">
                  <TextField
                    size="small"
                    variant="outlined"
                    type="text"
                    placeholder="Ej: 300 X 400"
                    defaultValue={
                      shoppingCart_v2[arteFinal._id]?.formatos[formatSelected.formatoId]?.formatoName !== undefined
                        ? shoppingCart_v2[arteFinal._id]?.formatos[formatSelected.formatoId]?.formatoName
                        : ''
                    }
                    InputProps={{
                      endAdornment: shoppingCart_v2[arteFinal._id]?.formatos[formatSelected.formatoId]?.formatoName ? (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <UpdateIcon
                            sx={{ color: 'action.active', cursor: 'pointer' }}
                            onClick={() =>
                              updateNameCustom({ arteFinalId: arteFinal._id, formatSelected, setShoppingCart_v2 })
                            }
                          />
                        </div>
                      ) : null,
                      style: {
                        textAlign: 'center',
                      },
                    }}
                    inputProps={{
                      style: {
                        textAlign: 'center',
                      },
                    }}
                    style={{ padding: '0 1rem' }}
                    onChange={(e) => handleChangeFormatoCustom({ e, setFormatSelected })}
                  />
                  <SelectMaterial />
                </div>
              )}
            {arteFinal.isInformational && (
              <div
                style={{
                  fontSize: '0.75rem',
                  color: '#666',
                  textAlign: 'center',
                  margin: '0.5rem 0 0',
                  lineHeight: 1.6,
                }}
              >
                <p style={{ margin: 0 }}>Tamaño y material orientativo.</p>
                <p style={{ margin: 0 }}>
                  Para adaptación contacta{' '}
                  <a
                    href="https://mail.google.com/mail/?view=cm&to=b.herraez@alcampo.es"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'inherit', fontWeight: 'bold' }}
                  >
                    b.herraez@alcampo.es
                  </a>
                  Con ?view=cm&to= abre Gmail directamente en la ventana de redacción con el destinatario ya puesto.
                </p>
              </div>
            )}
          </>
        )}

        {activeTab === 1 && (
          <div
            style={{
              fontSize: '0.8rem',
              color: '#444',
              whiteSpace: 'pre-wrap',
              padding: '0.25rem 3rem',
              lineHeight: 1.5,
              minHeight: '60px',
              maxHeight: 'calc(0.8rem * 1.5 * 11)',
              overflowY: 'auto',
            }}
          >
            {arteFinal?.description?.trim() ? arteFinal.description : <i>Sin descripción disponible.</i>}
          </div>
        )}
      </div>

      <FooterCard key={arteFinal._id} />
    </div>
  );
};

export default ContentArteNotDescargable;
